import {
  Companion_getInstance307sotgyzbnou as Companion_getInstance,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_scopeSet(_this__u8e3s4) {
  return _this__u8e3s4.prop(ChangeRequest_scopeSet_getInstance());
}
function get_linkItems(_this__u8e3s4) {
  return _this__u8e3s4.prop(ChangeRequest_linkItems_getInstance());
}
function get_cardinalChange(_this__u8e3s4) {
  return _this__u8e3s4.prop(ChangeRequest_cardinalChange_getInstance());
}
function get_title(_this__u8e3s4) {
  return _this__u8e3s4.prop(ChangeRequest_title_getInstance());
}
function get_description(_this__u8e3s4) {
  return _this__u8e3s4.prop(ChangeRequest_description_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(ChangeRequest_project_getInstance());
}
function get_number(_this__u8e3s4) {
  return _this__u8e3s4.prop(ChangeRequest_number_getInstance());
}
function prepareChangeRequestFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ChangeRequest__id_getInstance(), ChangeRequest_project_getInstance(), ChangeRequest_title_getInstance(), ChangeRequest_description_getInstance(), ChangeRequest_projectDescription_getInstance(), ChangeRequest_published_getInstance(), ChangeRequest_cardinalChange_getInstance(), ChangeRequest_linkItems_getInstance(), ChangeRequest_scopeSet_getInstance(), ChangeRequest_fullyLinked_getInstance(), ChangeRequest_pending_getInstance(), ChangeRequest_number_getInstance(), ChangeRequest_created_getInstance(), ChangeRequest_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ChangeRequest_scopeSet$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function ChangeRequest_scopeSet$_get_name_$ref_sxsztx() {
  return (p0) => p0.k20();
}
function ChangeRequest_scopeSet$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_scopeSet$_get_serializer_$ref_m720zi() {
  return (p0) => p0.j2j();
}
function ChangeRequest_scopeSet$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function ChangeRequest_scopeSet$_get_annotations_$ref_wp1a9y() {
  return (p0) => p0.bz();
}
var ChangeRequest_scopeSetClass;
function ChangeRequest_scopeSet() {
  if (ChangeRequest_scopeSetClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_scopeSet_instance = this;
        var tmp = this;
        tmp.k57_1 = lazy(ChangeRequest_scopeSet$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l57_1 = lazy(ChangeRequest_scopeSet$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m57_1 = lazy(ChangeRequest_scopeSet$annotations$delegate$lambda);
        this.n57_1 = false;
        this.o57_1 = 'false';
      }
      k20() {
        var tmp0 = this.k57_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_scopeSet$_get_name_$ref_sxsztx(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.y57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      e58(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.e58(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l57_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_scopeSet$_get_serializer_$ref_m720zi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m57_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_scopeSet$_get_annotations_$ref_wp1a9y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_scopeSet', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_scopeSetClass = $;
  }
  return ChangeRequest_scopeSetClass;
}
var ChangeRequest_scopeSet_instance;
function ChangeRequest_scopeSet_getInstance() {
  if (ChangeRequest_scopeSet_instance === VOID)
    new (ChangeRequest_scopeSet())();
  return ChangeRequest_scopeSet_instance;
}
function ChangeRequest_linkItems$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function ChangeRequest_linkItems$_get_name_$ref_d1mgq5() {
  return (p0) => p0.k20();
}
function ChangeRequest_linkItems$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_linkItems$_get_serializer_$ref_x7c0g6() {
  return (p0) => p0.j2j();
}
function ChangeRequest_linkItems$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function ChangeRequest_linkItems$_get_annotations_$ref_is2jr2() {
  return (p0) => p0.bz();
}
var ChangeRequest_linkItemsClass;
function ChangeRequest_linkItems() {
  if (ChangeRequest_linkItemsClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_linkItems_instance = this;
        var tmp = this;
        tmp.g58_1 = lazy(ChangeRequest_linkItems$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h58_1 = lazy(ChangeRequest_linkItems$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i58_1 = lazy(ChangeRequest_linkItems$annotations$delegate$lambda);
        this.j58_1 = false;
        this.k58_1 = 'false';
      }
      k20() {
        var tmp0 = this.g58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_linkItems$_get_name_$ref_d1mgq5(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.x57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      e58(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.e58(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_linkItems$_get_serializer_$ref_x7c0g6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_linkItems$_get_annotations_$ref_is2jr2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_linkItems', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_linkItemsClass = $;
  }
  return ChangeRequest_linkItemsClass;
}
var ChangeRequest_linkItems_instance;
function ChangeRequest_linkItems_getInstance() {
  if (ChangeRequest_linkItems_instance === VOID)
    new (ChangeRequest_linkItems())();
  return ChangeRequest_linkItems_instance;
}
function ChangeRequest_cardinalChange$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function ChangeRequest_cardinalChange$_get_name_$ref_q7ol2b() {
  return (p0) => p0.k20();
}
function ChangeRequest_cardinalChange$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_cardinalChange$_get_serializer_$ref_bjl3jw() {
  return (p0) => p0.j2j();
}
function ChangeRequest_cardinalChange$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function ChangeRequest_cardinalChange$_get_annotations_$ref_de3a9k() {
  return (p0) => p0.bz();
}
var ChangeRequest_cardinalChangeClass;
function ChangeRequest_cardinalChange() {
  if (ChangeRequest_cardinalChangeClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_cardinalChange_instance = this;
        var tmp = this;
        tmp.l58_1 = lazy(ChangeRequest_cardinalChange$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m58_1 = lazy(ChangeRequest_cardinalChange$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n58_1 = lazy(ChangeRequest_cardinalChange$annotations$delegate$lambda);
        this.o58_1 = false;
        this.p58_1 = 'false';
      }
      k20() {
        var tmp0 = this.l58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_cardinalChange$_get_name_$ref_q7ol2b(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.w57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      e58(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.e58(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_cardinalChange$_get_serializer_$ref_bjl3jw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_cardinalChange$_get_annotations_$ref_de3a9k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_cardinalChange', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_cardinalChangeClass = $;
  }
  return ChangeRequest_cardinalChangeClass;
}
var ChangeRequest_cardinalChange_instance;
function ChangeRequest_cardinalChange_getInstance() {
  if (ChangeRequest_cardinalChange_instance === VOID)
    new (ChangeRequest_cardinalChange())();
  return ChangeRequest_cardinalChange_instance;
}
function ChangeRequest_title$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ChangeRequest_title$_get_name_$ref_m4k1vf() {
  return (p0) => p0.k20();
}
function ChangeRequest_title$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_title$_get_serializer_$ref_kziqr0() {
  return (p0) => p0.j2j();
}
function ChangeRequest_title$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ChangeRequest_title$_get_annotations_$ref_retlzk() {
  return (p0) => p0.bz();
}
var ChangeRequest_titleClass;
function ChangeRequest_title() {
  if (ChangeRequest_titleClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_title_instance = this;
        var tmp = this;
        tmp.q58_1 = lazy(ChangeRequest_title$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r58_1 = lazy(ChangeRequest_title$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s58_1 = lazy(ChangeRequest_title$annotations$delegate$lambda);
        this.t58_1 = '';
        this.u58_1 = '""';
      }
      k20() {
        var tmp0 = this.q58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_title$_get_name_$ref_m4k1vf(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.s57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      v58(receiver, value) {
        return receiver.f58(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.v58(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_title$_get_serializer_$ref_kziqr0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_title$_get_annotations_$ref_retlzk(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_title', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_titleClass = $;
  }
  return ChangeRequest_titleClass;
}
var ChangeRequest_title_instance;
function ChangeRequest_title_getInstance() {
  if (ChangeRequest_title_instance === VOID)
    new (ChangeRequest_title())();
  return ChangeRequest_title_instance;
}
function ChangeRequest_description$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ChangeRequest_description$_get_name_$ref_sf8bpz() {
  return (p0) => p0.k20();
}
function ChangeRequest_description$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_description$_get_serializer_$ref_ao6whc() {
  return (p0) => p0.j2j();
}
function ChangeRequest_description$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ChangeRequest_description$_get_annotations_$ref_ulsoic() {
  return (p0) => p0.bz();
}
var ChangeRequest_descriptionClass;
function ChangeRequest_description() {
  if (ChangeRequest_descriptionClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_description_instance = this;
        var tmp = this;
        tmp.w58_1 = lazy(ChangeRequest_description$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x58_1 = lazy(ChangeRequest_description$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y58_1 = lazy(ChangeRequest_description$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.w58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_description$_get_name_$ref_sf8bpz(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.t57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      v58(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.v58(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_description$_get_serializer_$ref_ao6whc(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_description$_get_annotations_$ref_ulsoic(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_description', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_descriptionClass = $;
  }
  return ChangeRequest_descriptionClass;
}
var ChangeRequest_description_instance;
function ChangeRequest_description_getInstance() {
  if (ChangeRequest_description_instance === VOID)
    new (ChangeRequest_description())();
  return ChangeRequest_description_instance;
}
function ChangeRequest_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ChangeRequest_project$_get_name_$ref_sdio9y() {
  return (p0) => p0.k20();
}
function ChangeRequest_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_project$_get_serializer_$ref_hg2xal() {
  return (p0) => p0.j2j();
}
function ChangeRequest_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ChangeRequest_project$_get_annotations_$ref_baop69() {
  return (p0) => p0.bz();
}
var ChangeRequest_projectClass;
function ChangeRequest_project() {
  if (ChangeRequest_projectClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_project_instance = this;
        var tmp = this;
        tmp.z58_1 = lazy(ChangeRequest_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a59_1 = lazy(ChangeRequest_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b59_1 = lazy(ChangeRequest_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.z58_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_project$_get_name_$ref_sdio9y(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.r57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      c59(receiver, value) {
        return receiver.f58(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.c59(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_project$_get_serializer_$ref_hg2xal(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_project$_get_annotations_$ref_baop69(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_project', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_projectClass = $;
  }
  return ChangeRequest_projectClass;
}
var ChangeRequest_project_instance;
function ChangeRequest_project_getInstance() {
  if (ChangeRequest_project_instance === VOID)
    new (ChangeRequest_project())();
  return ChangeRequest_project_instance;
}
function ChangeRequest_number$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(11);
}
function ChangeRequest_number$_get_name_$ref_wjceza() {
  return (p0) => p0.k20();
}
function ChangeRequest_number$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_number$_get_serializer_$ref_mldqwt() {
  return (p0) => p0.j2j();
}
function ChangeRequest_number$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(11);
}
function ChangeRequest_number$_get_annotations_$ref_67ep0f() {
  return (p0) => p0.bz();
}
var ChangeRequest_numberClass;
function ChangeRequest_number() {
  if (ChangeRequest_numberClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_number_instance = this;
        var tmp = this;
        tmp.d59_1 = lazy(ChangeRequest_number$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e59_1 = lazy(ChangeRequest_number$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f59_1 = lazy(ChangeRequest_number$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.d59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_number$_get_name_$ref_wjceza(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.b58_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      v58(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.v58(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_number$_get_serializer_$ref_mldqwt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_number$_get_annotations_$ref_67ep0f(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_number', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_numberClass = $;
  }
  return ChangeRequest_numberClass;
}
var ChangeRequest_number_instance;
function ChangeRequest_number_getInstance() {
  if (ChangeRequest_number_instance === VOID)
    new (ChangeRequest_number())();
  return ChangeRequest_number_instance;
}
function ChangeRequest__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ChangeRequest__id$_get_name_$ref_35faqv() {
  return (p0) => p0.k20();
}
function ChangeRequest__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest__id$_get_serializer_$ref_1id1xq() {
  return (p0) => p0.j2j();
}
function ChangeRequest__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ChangeRequest__id$_get_annotations_$ref_846bf6() {
  return (p0) => p0.bz();
}
var ChangeRequest__idClass;
function ChangeRequest__id() {
  if (ChangeRequest__idClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest__id_instance = this;
        var tmp = this;
        tmp.g59_1 = lazy(ChangeRequest__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h59_1 = lazy(ChangeRequest__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i59_1 = lazy(ChangeRequest__id$annotations$delegate$lambda);
        this.j59_1 = Companion_getInstance_0().m2p();
        this.k59_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.g59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest__id$_get_name_$ref_35faqv(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.q57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      c59(receiver, value) {
        return receiver.f58(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.c59(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest__id$_get_serializer_$ref_1id1xq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest__id$_get_annotations_$ref_846bf6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest__id', VOID, VOID, [SerializableProperty()]);
    ChangeRequest__idClass = $;
  }
  return ChangeRequest__idClass;
}
var ChangeRequest__id_instance;
function ChangeRequest__id_getInstance() {
  if (ChangeRequest__id_instance === VOID)
    new (ChangeRequest__id())();
  return ChangeRequest__id_instance;
}
function ChangeRequest_projectDescription$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ChangeRequest_projectDescription$_get_name_$ref_aoqsxc() {
  return (p0) => p0.k20();
}
function ChangeRequest_projectDescription$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_projectDescription$_get_serializer_$ref_7dh4h5() {
  return (p0) => p0.j2j();
}
function ChangeRequest_projectDescription$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ChangeRequest_projectDescription$_get_annotations_$ref_ladol() {
  return (p0) => p0.bz();
}
var ChangeRequest_projectDescriptionClass;
function ChangeRequest_projectDescription() {
  if (ChangeRequest_projectDescriptionClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_projectDescription_instance = this;
        var tmp = this;
        tmp.l59_1 = lazy(ChangeRequest_projectDescription$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m59_1 = lazy(ChangeRequest_projectDescription$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n59_1 = lazy(ChangeRequest_projectDescription$annotations$delegate$lambda);
        this.o59_1 = null;
        this.p59_1 = 'null';
      }
      k20() {
        var tmp0 = this.l59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_projectDescription$_get_name_$ref_aoqsxc(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.u57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      q59(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.q59(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_projectDescription$_get_serializer_$ref_7dh4h5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_projectDescription$_get_annotations_$ref_ladol(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_projectDescription', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_projectDescriptionClass = $;
  }
  return ChangeRequest_projectDescriptionClass;
}
var ChangeRequest_projectDescription_instance;
function ChangeRequest_projectDescription_getInstance() {
  if (ChangeRequest_projectDescription_instance === VOID)
    new (ChangeRequest_projectDescription())();
  return ChangeRequest_projectDescription_instance;
}
function ChangeRequest_published$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ChangeRequest_published$_get_name_$ref_46y885() {
  return (p0) => p0.k20();
}
function ChangeRequest_published$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_published$_get_serializer_$ref_cz2vuq() {
  return (p0) => p0.j2j();
}
function ChangeRequest_published$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ChangeRequest_published$_get_annotations_$ref_7vhtvq() {
  return (p0) => p0.bz();
}
var ChangeRequest_publishedClass;
function ChangeRequest_published() {
  if (ChangeRequest_publishedClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_published_instance = this;
        var tmp = this;
        tmp.r59_1 = lazy(ChangeRequest_published$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s59_1 = lazy(ChangeRequest_published$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t59_1 = lazy(ChangeRequest_published$annotations$delegate$lambda);
        this.u59_1 = null;
        this.v59_1 = 'null';
      }
      k20() {
        var tmp0 = this.r59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_published$_get_name_$ref_46y885(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.v57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      w59(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.w59(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_published$_get_serializer_$ref_cz2vuq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_published$_get_annotations_$ref_7vhtvq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_published', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_publishedClass = $;
  }
  return ChangeRequest_publishedClass;
}
var ChangeRequest_published_instance;
function ChangeRequest_published_getInstance() {
  if (ChangeRequest_published_instance === VOID)
    new (ChangeRequest_published())();
  return ChangeRequest_published_instance;
}
function ChangeRequest_fullyLinked$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function ChangeRequest_fullyLinked$_get_name_$ref_4ljpww() {
  return (p0) => p0.k20();
}
function ChangeRequest_fullyLinked$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_fullyLinked$_get_serializer_$ref_kbbuif() {
  return (p0) => p0.j2j();
}
function ChangeRequest_fullyLinked$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function ChangeRequest_fullyLinked$_get_annotations_$ref_6kvulh() {
  return (p0) => p0.bz();
}
var ChangeRequest_fullyLinkedClass;
function ChangeRequest_fullyLinked() {
  if (ChangeRequest_fullyLinkedClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_fullyLinked_instance = this;
        var tmp = this;
        tmp.x59_1 = lazy(ChangeRequest_fullyLinked$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y59_1 = lazy(ChangeRequest_fullyLinked$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z59_1 = lazy(ChangeRequest_fullyLinked$annotations$delegate$lambda);
        this.a5a_1 = false;
        this.b5a_1 = 'false';
      }
      k20() {
        var tmp0 = this.x59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_fullyLinked$_get_name_$ref_4ljpww(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.z57_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      e58(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.e58(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_fullyLinked$_get_serializer_$ref_kbbuif(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z59_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_fullyLinked$_get_annotations_$ref_6kvulh(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_fullyLinked', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_fullyLinkedClass = $;
  }
  return ChangeRequest_fullyLinkedClass;
}
var ChangeRequest_fullyLinked_instance;
function ChangeRequest_fullyLinked_getInstance() {
  if (ChangeRequest_fullyLinked_instance === VOID)
    new (ChangeRequest_fullyLinked())();
  return ChangeRequest_fullyLinked_instance;
}
function ChangeRequest_pending$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function ChangeRequest_pending$_get_name_$ref_mm6ue4() {
  return (p0) => p0.k20();
}
function ChangeRequest_pending$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_pending$_get_serializer_$ref_2bs9px() {
  return (p0) => p0.j2j();
}
function ChangeRequest_pending$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function ChangeRequest_pending$_get_annotations_$ref_ezgr69() {
  return (p0) => p0.bz();
}
var ChangeRequest_pendingClass;
function ChangeRequest_pending() {
  if (ChangeRequest_pendingClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_pending_instance = this;
        var tmp = this;
        tmp.c5a_1 = lazy(ChangeRequest_pending$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d5a_1 = lazy(ChangeRequest_pending$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e5a_1 = lazy(ChangeRequest_pending$annotations$delegate$lambda);
        this.f5a_1 = 0;
        this.g5a_1 = '0';
      }
      k20() {
        var tmp0 = this.c5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_pending$_get_name_$ref_mm6ue4(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.a58_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      h5a(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.h5a(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_pending$_get_serializer_$ref_2bs9px(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_pending$_get_annotations_$ref_ezgr69(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_pending', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_pendingClass = $;
  }
  return ChangeRequest_pendingClass;
}
var ChangeRequest_pending_instance;
function ChangeRequest_pending_getInstance() {
  if (ChangeRequest_pending_instance === VOID)
    new (ChangeRequest_pending())();
  return ChangeRequest_pending_instance;
}
function ChangeRequest_created$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(12);
}
function ChangeRequest_created$_get_name_$ref_wmsfmd() {
  return (p0) => p0.k20();
}
function ChangeRequest_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_created$_get_serializer_$ref_i6v4ak() {
  return (p0) => p0.j2j();
}
function ChangeRequest_created$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(12);
}
function ChangeRequest_created$_get_annotations_$ref_brlbsw() {
  return (p0) => p0.bz();
}
var ChangeRequest_createdClass;
function ChangeRequest_created() {
  if (ChangeRequest_createdClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_created_instance = this;
        var tmp = this;
        tmp.i5a_1 = lazy(ChangeRequest_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j5a_1 = lazy(ChangeRequest_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k5a_1 = lazy(ChangeRequest_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.l5a_1 = get_default(Companion_instance).d1m();
        this.m5a_1 = 'now()';
      }
      k20() {
        var tmp0 = this.i5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_created$_get_name_$ref_wmsfmd(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.c58_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      n5a(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.n5a(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_created$_get_serializer_$ref_i6v4ak(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_created$_get_annotations_$ref_brlbsw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_created', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_createdClass = $;
  }
  return ChangeRequest_createdClass;
}
var ChangeRequest_created_instance;
function ChangeRequest_created_getInstance() {
  if (ChangeRequest_created_instance === VOID)
    new (ChangeRequest_created())();
  return ChangeRequest_created_instance;
}
function ChangeRequest_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(13);
}
function ChangeRequest_readBy$_get_name_$ref_l2eiqu() {
  return (p0) => p0.k20();
}
function ChangeRequest_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[13];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequest_readBy$_get_serializer_$ref_gek3lt() {
  return (p0) => p0.j2j();
}
function ChangeRequest_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(13);
}
function ChangeRequest_readBy$_get_annotations_$ref_rf7sgr() {
  return (p0) => p0.bz();
}
var ChangeRequest_readByClass;
function ChangeRequest_readBy() {
  if (ChangeRequest_readByClass === VOID) {
    class $ {
      constructor() {
        ChangeRequest_readBy_instance = this;
        var tmp = this;
        tmp.o5a_1 = lazy(ChangeRequest_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p5a_1 = lazy(ChangeRequest_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q5a_1 = lazy(ChangeRequest_readBy$annotations$delegate$lambda);
        this.r5a_1 = emptySet();
        this.s5a_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.o5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequest_readBy$_get_name_$ref_l2eiqu(), null);
        return tmp0.f2();
      }
      p57(receiver) {
        return receiver.d58_1;
      }
      m2j(receiver) {
        return this.p57(receiver instanceof ChangeRequest() ? receiver : THROW_CCE());
      }
      t5a(receiver, value) {
        return receiver.f58(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequest() ? receiver : THROW_CCE();
        return this.t5a(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequest_readBy$_get_serializer_$ref_gek3lt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequest_readBy$_get_annotations_$ref_rf7sgr(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequest_readBy', VOID, VOID, [SerializableProperty()]);
    ChangeRequest_readByClass = $;
  }
  return ChangeRequest_readByClass;
}
var ChangeRequest_readBy_instance;
function ChangeRequest_readBy_getInstance() {
  if (ChangeRequest_readBy_instance === VOID)
    new (ChangeRequest_readBy())();
  return ChangeRequest_readBy_instance;
}
//region block: exports
export {
  get_cardinalChange as get_cardinalChangeebt4rzfla0rg,
  get_description as get_descriptionchu6hh0rofv7,
  get_linkItems as get_linkItems1axtwhl2yveby,
  get_number as get_number1h0r9mzxgakil,
  prepareChangeRequestFields as prepareChangeRequestFields37ox4nkpqy655,
  get_project as get_projectgtrfvpc0zfzj,
  get_scopeSet as get_scopeSet2gpz9zq10ib51,
  get_title as get_title1uuo24n337kui,
};
//endregion

//# sourceMappingURL=ChangeRequestFields.mjs.map
